import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useSpring, animated } from 'react-spring';
import RightFooter from "../common/RightFooter";
import {imagesEN, wordsEN, ImagesAndWordsEN} from "./../../Utils/Constants";
import t from "../../Utils/Translation";
import LykioButton from "../common/LykioButton";
import { useNavigate } from "react-router";
import {Box, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {styled} from "@mui/material/styles";
import {
	AUTHORIZED_URL_PREFIX,
	AxiosConfig
} from '../../Utils/Constants';
import axios from 'axios'
import {startActivitySession, stopActivitySession, useUpdateActivitySession} from "../../Utils/TimerUtils";

const math = require('mathjs');




const LykioCustomButton = styled(Button)(() => ({
  background: 'linear-gradient(to bottom, #960000, #f1414f)',
  color: "white",
  '&:hover': {
    background: "white",
    color: "#960000",
    borderStyle: 'solid !important',
    borderWidth: '0.2em',
    borderRadius: '7px',
    borderColor: "#960000"
  },
}));

const TestEN = () => {
  const testId = 't001';
  const [level1Data, setLevel1Data] = useState(null);
  const [level2Data, setLevel2Data] = useState(null);
  const [level3Data, setLevel3Data] = useState(null);
  const [level4Data, setLevel4Data] = useState(null);
  const [level5Data, setLevel5Data] = useState(null);
  const [level6Data, setLevel6Data] = useState(null);
  const [level7Data, setLevel7Data] = useState(null);
  const [biasMaleInCareer, setBiasMaleInCareer] = useState(false);
  const [biasFemaleInCareer, setBiasFemaleInCareer] = useState(false);
  const [biasFree, setBiasFree] = useState(false);
  const [biasLevel, setBiasLevel] = useState(-1); // 0 = zero , 1 = slight/moderate, 2 = high/intense
  const [nullTest, setNullTest] = useState(false);

  function shuffleArray(array, size) {
    // First, create a copy of the input array
    let result = array.slice();
  
    // If the array has fewer than <size> elements, repeat some elements
    // until we have exactly <size>
    if(result.length < size) {
      result = doubleArray(result);
    }
  
    // Then, use the Fisher-Yates shuffle algorithm to shuffle the elements
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
  
    // Finally, return the first <size> elements of the shuffled array
    return result.slice(0, size);
  }

  function doubleArray(array) {
    // First, create a copy of the input array
    let result = array.slice();
  
    // Then, concatenate the array with itself to create a new array
    // that is twice the size of the original
    result = result.concat(array);
  
    // Finally, return the new array
    return result;
  }

  

  function sendDataFromSequence(data, sequence) {
    console.log('This is the data received from the sequence >'+sequence);
    console.log(data);

    if(sequence===1){
      //console.log('setting level 1');
      setLevel1Data(data);
    }
    if(sequence===2){
      //console.log('setting level 2');
      setLevel2Data(data);
    }
    if(sequence===3){
      //console.log('setting level 3');
      setLevel3Data(data);
    }
    if(sequence===4){
      //console.log('setting level 4');
      setLevel4Data(data);
    }
    if(sequence===5){
      //console.log('setting level 5');
      setLevel5Data(data);
    }
    if(sequence===6){
      //console.log('setting level 6');
      setLevel6Data(data);
    }
    if(sequence===7){
      //console.log('setting level 7');
      setLevel7Data(data);
      console.log('*** will call handleCalculateAndSaveResults after the level 7 with data');
      console.log(data);
      handleCalculateAndSaveResults(data);
    }
  }

  const [currentChild, setCurrentChild] = useState(1);

  const handleButtonClick = () => {
    console.log('pressing handleButtonClick')
    console.log('currentChild'+currentChild);
    console.log(`setting current child to ${(currentChild + 1) % 17}`);
    setCurrentChild((currentChild + 1) % 17);
  }

  const [isRunning, setIsRunning] = useState(false);

  useUpdateActivitySession(testId, isRunning);

  useEffect(() => {
    console.log('CRURRENT :', currentChild);
    if (currentChild === 2) {
      startActivitySession(testId)
    } else if([3,4,5,6,7,8,9,10,11,12,13,14,15].includes(currentChild)) {
      setIsRunning(true)
    } else {
      setIsRunning(false)
    }
  },[currentChild])

  let childComponent;

  switch (currentChild) {
    case 1:
      childComponent = <TestWelcome/>;
    break;
    case 2:
      childComponent = <IntroToSequence1/>;
    break;
    case 3:
      childComponent = <Sequence1 
      images={shuffleArray(imagesEN, 20)} sequenceIndex={1} leftAttribute1={'MASCULINE'} rightAttribute1={'FEMININE'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick}/>;
      break;
    case 4:
      childComponent = <IntroToSequence2/>;
    break;
    case 5:
      childComponent = <Sequence2 images={shuffleArray(wordsEN, 20)} sequenceIndex={2} leftAttribute1={'CAREER'} rightAttribute1={'FAMILY'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick}/>;
      break;
    case 6:
      childComponent = <IntroToSequence3and4/>;
    break;
    case 7:
      childComponent = <Sequence3 images={shuffleArray(ImagesAndWordsEN, 20)} sequenceIndex={3} leftAttribute1={'MASCULINE'} leftAttribute2={'CAREER'} rightAttribute1={'FEMININE'} rightAttribute2={'FAMILY'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick}/>;
      break;
    case 8:
      childComponent = <IntroToSequence3and4/>;
    break;  
    case 9:
      childComponent = <Sequence4 images={shuffleArray(ImagesAndWordsEN, 40)} sequenceIndex={4} leftAttribute1={'MASCULINE'} leftAttribute2={'CAREER'} rightAttribute1={'FEMININE'} rightAttribute2={'FAMILY'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick}/>;
      break;
    case 10:
      childComponent = <IntroToSequence5/>;
    break;  
    case 11:
      childComponent = <Sequence5 images={shuffleArray(imagesEN, 28)} sequenceIndex={5} 
      leftAttribute1={'FEMININE'} 
      rightAttribute1={'MASCULINE'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick}/>;
    break;
    case 12:
      childComponent = <IntroToSequence6and7/>;
    break;  
    case 13:
      childComponent = <Sequence6 images={shuffleArray(ImagesAndWordsEN, 20)} sequenceIndex={6} 
      leftAttribute1={'FEMININE'} leftAttribute2={'CAREER'} rightAttribute1={'MASCULINE'} rightAttribute2={'FAMILY'}
      sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick}/>;
    break;
    case 14:
      childComponent = <IntroToSequence6and7/>;
    break;  
    case 15:
      childComponent = <Sequence7 images={shuffleArray(ImagesAndWordsEN, 40)} sequenceIndex={7} 
      leftAttribute1={'FEMININE'} leftAttribute2={'CAREER'} rightAttribute1={'MASCULINE'} rightAttribute2={'FAMILY'}
      sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick}/>;
    break;
    case 16:
      childComponent = Results(biasFree, biasMaleInCareer, biasFemaleInCareer, biasLevel);
      break;
    default:
      childComponent = <div style={{color:'black'}}>Error, please refresh</div>;
  }

  const handleCalculateAndSaveResults = async(level7dataFromCaller) => {
    console.log('level7dataFromCaller is>>>')
    console.log(level7dataFromCaller);
    let localBiasMaleInCareer = false;
    let localBiasFemaleInCareer = false;
    let localBiasLevel = 0;
    let localBiasFree = false;
    let localNullTry = false;

    console.log('*** Will now log the level4 and level7 results>>> ');
    console.log(level4Data);
    console.log(level7dataFromCaller ? level7dataFromCaller : level7Data);

    let localLevel7Data = level7dataFromCaller ? level7dataFromCaller : level7Data;

    if(level1Data && level2Data && level3Data && level4Data && level5Data && level6Data && localLevel7Data && level4Data.percentage>75 && localLevel7Data.percentage>75){
      // check that the have at least 75% correct
      if(level4Data.timeSpent-localLevel7Data.timeSpent >= 4){
        // then the user has a gender-related bias in sorting MALE in CAREER and FEMALE in FAMILY
        setBiasMaleInCareer(true);
        localBiasMaleInCareer = true;
        // if leve3 average time is <2 zero, if >=2 <4 slight, if > 4 high
        if(level4Data.averageTime<0.25){
            setBiasLevel(0);
            localBiasLevel = 0;
        }
        else if(level4Data.averageTime<0.5){
          setBiasLevel(1);
          localBiasLevel = 1;
        }else{
          setBiasLevel(2);
          localBiasLevel = 2
        }
      }
      else if(localLevel7Data.timeSpent-level4Data.timeSpent >= 4){
        // then the user has a gender-related bias in sorting MALE in FAMILY and FEMALE in CAREER
        setBiasFemaleInCareer(true);
        localBiasFemaleInCareer = true;
        if(localLevel7Data.averageTime<0.25){
          setBiasLevel(0);
          localBiasLevel = 0;
        }
        else if(localLevel7Data.averageTime<0.5){
          setBiasLevel(1);
          localBiasLevel = 1;
        }else{
          setBiasLevel(2);
          localBiasLevel = 2;
        }
      }
      else{
        setBiasFree(true);
        localBiasFree = true;
      }

    }else{
      //null
      setNullTest(true);
      localNullTry = true;
    }

    // send data back to server
    const results = {
      id: testId,
      type: "Test",
      localBiasMaleInCareer,
      localBiasFemaleInCareer,
      localBiasLevel,
      localBiasFree,
      localNullTry
    }
//TODO: call the stopActivitySession(testid, success) where success is if complete the activity with positive score
    if (localBiasLevel === 0 && !localNullTry) {
      stopActivitySession(testId, true)
    } else {
      stopActivitySession(testId, false)
    }

    const { data } = await axios.post(
      `${AUTHORIZED_URL_PREFIX}${"/user/saveResults"}`,
      {results: results},
      AxiosConfig()
    )
    if (!data.success) {
      console.log('error sending data to the server');
    }
  }

  const showResults = () => {
    console.log('*** will showResults');
    handleCalculateAndSaveResults();

    handleButtonClick();
    handleCalculateAndSaveResults();
  }


  useEffect(() => {
    function handleParentKeyDown(event) {
      if (event.key === " " || event.key === "Spacebar") {
        if(currentChild === 1 && !level1Data){
          console.log('1 pressing handleButtonClick'); 
          handleButtonClick();
        }
        if(currentChild === 2 && !level1Data){
          console.log('2 pressing handleButtonClick');
          handleButtonClick();
        }
        if(currentChild === 3 && level1Data){
          console.log('3 pressing handleButtonClick');
          handleButtonClick();
        }
        if(currentChild === 4 && !level2Data){
          console.log('4 pressing handleButtonClick');
          handleButtonClick();
        }
        if(currentChild === 6 && !level3Data){
          console.log('6 pressing handleButtonClick');
          handleButtonClick();
        }
        if(currentChild === 8 && !level4Data){
          console.log('8 pressing handleButtonClick');
          handleButtonClick();
        }
        if(currentChild === 10 && !level5Data){
          console.log('10 pressing handleButtonClick');
          handleButtonClick();
        }
        if(currentChild === 12 && !level6Data){
          console.log('12 pressing handleButtonClick');
          handleButtonClick();
        }
        if(currentChild === 14 && !level7Data){
          console.log('14 pressing handleButtonClick');
          handleButtonClick();
        }
      }
    }

      // Add the event listener
  document.addEventListener('keydown', handleParentKeyDown);

  // Remove the event listener when the component unmounts
  return () => {
    document.removeEventListener('keydown', handleParentKeyDown);
  };
  }, [currentChild]);

  return <div className="lykioccs-main-content lykiocss-test">
            {childComponent}
          <Row>
          <div className="lykiocss-center">
              {currentChild === 1 && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Start')}</LykioCustomButton>}

              {currentChild === 2 && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('FIRST STEP')}</LykioCustomButton>}

              {currentChild === 3  && level1Data && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}
              
              {currentChild === 4 && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}
              
              {currentChild === 5 && level2Data && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}
              
              {currentChild === 6 && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

              {currentChild === 7 && level3Data && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}
              
              {currentChild === 8 && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}
              
              {currentChild === 9 && level4Data && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}
              
              {currentChild === 10 && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

              {currentChild === 11 && level5Data && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

              {currentChild === 12 && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

              {currentChild === 13 && level6Data && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

              {currentChild === 14 && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

              {currentChild === 15 && level7Data && <LykioCustomButton style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={showResults}>{t('Show Results')}</LykioCustomButton>}
            </div>
          </Row>
            <RightFooter />
        </div>
};

export default TestEN;


function TestWelcome() {
  return         <>
  <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
  <Container className="lykiocss-margin-top-1em">
  <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
          <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'20em'}} className="lykiocss-center">
              {t('TEST-GENDER/CAREER')}
          </div>
  </Row>

  <Row className="lykiocss-center">
    <Box
        style={{background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth:'50em'}}
        color="white"
        borderRadius={3}
        p={3}
        m={2}
        textAlign={'center'}
        justifyContent="center"
        alignItems="center"
    >
    <p style={{ fontSize: '21px', textAlign:"left" }}>
    This test - devised based on the Implicit Association Test (IAT) developed by researchers at Harvard - aims to identify patterns and tendencies regarding mental associations between gender and career or family.
    </p>
    <p style={{ fontSize: '21px', textAlign:"left" }}>
    The test allows for the detection of biases that sometimes unconsciously lead to associating men with careers and women with family roles, significantly influencing choices during the personnel selection process.
    </p>
    <p style={{ fontSize: '21px', textAlign:"left" }}>
    The test measures participants' response speed and accuracy, calculating a score that reflects the strength of their implicit associations. It is not a diagnostic test but rather a tool to increase awareness of potential unconscious biases and explore ways to address them.
    </p>
    <br />

    <p style={{ fontSize: '21px', textAlign:"left" }}>
    START 
    </p>

    <p style={{ fontSize: '21px', textAlign:"left", marginLeft:"1em" }}>
    1. Before starting the test, please place your fingers on the A and L keys on the keyboard.
    </p>

    <p style={{ fontSize: '21px', textAlign:"left", marginLeft:"1em"  }}>
    2. During the test, you will see a series of words and images on the screen. Follow the instructions and respond as quickly as possible by pressing the A key for one category and the L key for the other.
    </p>

    <p style={{ fontSize: '21px', textAlign:"left", marginLeft:"1em"  }}>
    3. Respond quickly and instinctively.
    </p>

    <br />
    <p style={{ fontSize: '21px' , textAlign:"left"}}>
    TO BEGIN, click the space bar or the left mouse button.
    </p>

    <br />


    </Box>
  </Row>
  </Container>
  </div>
</>;
}

function Results(biasFree, biasMaleInCareer, biasFemaleInCareer, biasLevel) {

  let text = <div style={{fontSize:'21px'}}><p>{t("You made too many errors in some parts of the test. Please try again.")}</p></div>;
  if(biasFree || biasLevel === 0){
    text = <div style={{fontSize:'21px'}}>
      <p>Thank you for taking the test and showing interest in identifying any potential unconscious biases.</p>
      <p><span style={{fontWeight:'900'}}>Based on your results, you have not demonstrated any significant implicit bias regarding the association between gender and career.</span></p>
      <p>This is a very positive outcome, suggesting that you have an open attitude and do not exhibit particular biases towards people's gender and the roles they may choose to assume.</p>
    </div>
  }else{
    if(biasMaleInCareer && biasLevel === 1){
      text= <div style={{fontSize:'21px'}}>
        <p>Thank you for taking the test and showing interest in identifying any potential unconscious biases.</p>
        <p><span style={{fontWeight:'900'}}>The test results suggest a slight tendency for bias in automatically associating male figures with the concept of a career and female figures with the concept of family.</span></p>
        <p>Having biases is natural, and your results are not necessarily related to your intentions, beliefs, or moral values. Biases can be involuntary and may stem from various factors, including personal experiences, cultural background, social norms, and media representations.</p>
        <p>Our education and cultural context can shape our beliefs and attitudes about gender roles, often unconsciously. Even if we consciously believe in gender equality and support it, we may still have some unconscious biases that influence our behavior and decisions.</p>
        <p>For example, someone who grew up in an environment where female figures are primarily responsible for taking care of the home and family might unconsciously assume that a female candidate would be more suitable for a supportive or caregiving role rather than a leadership or managerial position.</p>
        <p>It is essential to recognize and challenge these unconscious biases in ourselves and others to promote greater gender equality and diversity in all aspects of life.</p>
      </div>
    }
    if(biasMaleInCareer && biasLevel === 2){
      text= <div style={{fontSize:'21px'}}>
        <p>Thank you for taking the test and showing interest in identifying any potential unconscious biases.</p>
        <p><span style={{fontWeight:'900'}}>The test results suggest a strong bias in automatically associating male figures with the concept of a career and female figures with the concept of family.</span></p>
        <p>Having biases is natural, and your results are not necessarily related to your intentions, beliefs, or moral values. Biases can be involuntary and may stem from various factors, including personal experiences, cultural background, social norms, and media representations.</p>
        <p>Our education and cultural context can shape our beliefs and attitudes about gender roles, often unconsciously. Even if we consciously believe in gender equality and support it, we may still have some unconscious biases that influence our behavior and decisions.</p>
        <p>For example, someone who grew up in an environment where female figures are primarily responsible for taking care of the home and family might unconsciously assume that a female candidate would be more suitable for a supportive or caregiving role rather than a leadership or managerial position.</p>
        <p>It is essential to recognize and challenge these unconscious biases in ourselves and <span style={{fontWeight:'900'}}>others to promote greater gender equality and diversity in all aspects of life.</span></p>
      </div>
    }

    if(biasFemaleInCareer && biasLevel === 1){
      text= <div style={{fontSize:'21px'}}>
        <p>Thank you for taking the test and showing interest in identifying any potential unconscious biases.</p>
        <p><span style={{fontWeight:'900'}}>The test results suggest a slight tendency for bias in automatically associating female figures with the concept of a career and male figures with the concept of family.</span></p>
        <p>Having biases is natural, and your results are not necessarily related to your intentions, beliefs, or moral values. Biases can be involuntary and may stem from various factors, including personal experiences, cultural background, social norms, and media representations.</p>
        <p>Our education and cultural context can shape our beliefs and attitudes about gender roles, often unconsciously. Even if we consciously believe in gender equality and support it, we may still have some unconscious biases that influence our behavior and decisions.</p>
        <p>For example, someone who grew up in an environment where female figures are primarily responsible for taking care of the home and family might unconsciously as sume that a female candidate would be more suitable for a supportive or caregiving role rather than a leadership or managerial position.</p>
        <p>It is essential to recognize and challenge these unconscious biases in ourselves and others to promote greater gender equality and diversity in all aspects of life.</p>
      </div>
    }

    if(biasFemaleInCareer && biasLevel === 2){
      text= <div style={{fontSize:'21px'}}>
        <p>Thank you for taking the test and showing interest in identifying any potential unconscious biases.</p>
        <p><span style={{fontWeight:'900'}}>The test results suggest a strong bias in automatically associating female figures with the concept of a career and male figures with the concept of family.</span></p>
        <p>Having biases is natural, and your results are not necessarily related to your intentions, beliefs, or moral values. Biases can be involuntary and may stem from various factors, including personal experiences, cultural background, social norms, and media representations.</p>
        <p>Our education and cultural context can shape our beliefs and attitudes about gender roles, often unconsciously. Even if we consciously believe in gender equality and support it, we may still have some unconscious biases that influence our behavior and decisions.</p>
        <p>For example, someone who grew up in an environment where female figures are primarily responsible for taking care of the home and family might unconsciously assume that a female candidate would be more suitable for a supportive or caregiving role rather than a leadership or managerial position.</p>
        <p>It is essential to recognize and challenge these unconscious biases in ourselves and others to promote greater gender equality and diversity in all aspects of life.</p>
      </div>
    }

  }



  return <div className="lykiocss-center margin lykiocss-margin-top-4em" style={{ color: 'black' }}>
    <Container>
    <div style={{display:'flex', justifyContent: 'center'}}>
    <Box
        style={{background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth:'50em'}}
        color="white"
        borderRadius={8}
        p={3}
        m={2}
        textAlign={'center'}
        justifyContent="center"
        alignItems="center"
    >
      <Row>
        <div className="lykiocss-center">{text}</div>
      </Row>
  </Box>
  </div>
  <Row>
    <a className="lykiocss-center lykiocss-margin-top-2em" href="/" style={{textDecoration: 'none'}}>
    <LykioButton style={{background: "linear-gradient(to bottom, #960000, #f1414f)" , fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}}>
      {t("END")}
    </LykioButton>
    </a>
  </Row>
    </Container>
  </div>;
}

function IntroToSequence1(props){
  return         <>
  <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
  <Container className="lykiocss-margin-top-1em">
  <Row className="lykiocss-center">
    <Box
        style={{background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth:'50em',position:'relative'}}
        color="white"
        borderRadius={10}
        p={3}
        m={2}
        textAlign={'center'}
        justifyContent="center"
        alignItems="center"
    >

    <div style={{position:'absolute', left:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          A
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
            MASCULINE
          </span>
        </p>
      </div>
    </div>
    <div style={{position:'absolute', right:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
        {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          L
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
            FEMININE
          </span>
        </p>
      </div>
    </div>
    <div style={{fontSize:'21px', marginTop:'6em'}}>
      <p>
      You will be shown a series of pictures.
      </p>
      <p>
      Press «A» to associate the pictures with the «MASCULINE» category.
      Press «L» to associate the pictures with the «FEMININE» category.
      </p>
      <p>
      If you make a pairing error, the system will notify you and provide the option to correct your answer.
      </p>
    </div>
    </Box>
    
    <div className="lykiocss-center" style={{margin:'0', fontWeight:'600', fontSize:'18px'}}>
      {t("Click on the space bar or on the left mouse button")}
    </div>
     
  </Row>
  </Container>
  </div>
</>;
}

function IntroToSequence2(props){
  return         <>
  <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
  <Container className="lykiocss-margin-top-1em">
  <Row className="lykiocss-center">
    <Box
        style={{background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth:'50em',position:'relative'}}
        color="white"
        borderRadius={10}
        p={3}
        m={2}
        textAlign={'center'}
        justifyContent="center"
        alignItems="center"
    >

    <div style={{position:'absolute', left:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          A
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
            CAREER
          </span>
        </p>
      </div>
    </div>
    <div style={{position:'absolute', right:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          L
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
            FAMILY
          </span>
        </p>
      </div>
    </div>
    <div style={{fontSize:'21px', marginTop:'6em'}}>
      <p>
      You will be shown a series of words.
      </p>
      <p>
      Press «A» to associate the words with the «CAREER» category.
      Press «L» to associate the words with the «FAMILY» category.
      </p>
      <p>
      If you make a pairing error, the system will notify you and provide the option to correct your answer.
      </p>
    </div>
    </Box>
    
    <div className="lykiocss-center" style={{margin:'0', fontWeight:'600', fontSize:'18px'}}>
      {t("Click on the space bar or on the left mouse button")}
    </div>
     
  </Row>
  </Container>
  </div>
</>;
}

function IntroToSequence3and4(props){
  return         <>
  <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
  <Container className="lykiocss-margin-top-1em">
  <Row className="lykiocss-center">
    <Box
        style={{background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth:'50em',position:'relative'}}
        color="white"
        borderRadius={10}
        p={3}
        m={2}
        textAlign={'center'}
        justifyContent="center"
        alignItems="center"
    >

    <div style={{position:'absolute', left:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          A
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
            MASCULINE
          </span>
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          or
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
            CAREER
          </span>
        </p>
      </div>
    </div>
    <div style={{position:'absolute', right:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          L
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
          FEMININE
          </span>
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
        or
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
          FAMILY
          </span>
        </p>
      </div>
    </div>
    <div style={{fontSize:'21px', marginTop:'8em'}}>
      <p>
      You will be shown a series of pictures and words.
      </p>
      <p>
      Press «A» to associate the elements with the «MASCULINE» and «CAREER» category.
      Press «L» to associate the elements with the «FEMININE» and «FAMILY» category.
      </p>
      <p>
      If you make a pairing error, the system will notify you and provide the option to correct your answer.
      </p>
    </div>
    </Box>
    
    <div className="lykiocss-center" style={{margin:'0', fontWeight:'600', fontSize:'18px'}}>
      {t("Click on the space bar or on the left mouse button")}
    </div>
     
  </Row>
  </Container>
  </div>
</>;
}

function IntroToSequence5(props){
  return         <>
  <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
  <Container className="lykiocss-margin-top-1em">
  <Row className="lykiocss-center">
    <Box
        style={{background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth:'50em',position:'relative'}}
        color="white"
        borderRadius={10}
        p={3}
        m={2}
        textAlign={'center'}
        justifyContent="center"
        alignItems="center"
    >

    <div style={{position:'absolute', left:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          A
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
          FEMININE
          </span>
        </p>
      </div>
    </div>
    <div style={{position:'absolute', right:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          L
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
            MASCULINE
          </span>
        </p>
      </div>
    </div>
    <div style={{fontSize:'21px', marginTop:'6em'}}>
      <p>
      You will be shown a series of pictures.
      </p>
      <p>
      Press «A» to associate the pictures with the «FEMININE» category.
      Press «L» to associate the pictures with the «MASCULINE» category.
      </p>
      <p>
      If you make a pairing error, the system will notify you and provide the option to correct your answer.
      </p>
    </div>
    </Box>
    
    <div className="lykiocss-center" style={{margin:'0', fontWeight:'600', fontSize:'18px'}}>
      {t("Click on the space bar or on the left mouse button")}
    </div>
     
  </Row>
  </Container>
  </div>
</>;
}

function IntroToSequence6and7(props){
  return         <>
  <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
  <Container className="lykiocss-margin-top-1em">
  <Row className="lykiocss-center">
    <Box
        style={{background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth:'50em',position:'relative'}}
        color="white"
        borderRadius={10}
        p={3}
        m={2}
        textAlign={'center'}
        justifyContent="center"
        alignItems="center"
    >

    <div style={{position:'absolute', left:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          A
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
          FEMININE
          </span>
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
        or
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
            CAREER
          </span>
        </p>
      </div>
    </div>
    <div style={{position:'absolute', right:'30px', top:'10px'}}>
      <div style={{position:'relative'}}>
        <p style={{marginBottom:'0em', fontSize:'17px'}}>
          {t("Press")}
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
          L
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
          MASCULINE
          </span>
        </p>
        <p style={{marginBottom:'0.4em',fontWeight:'700', fontSize:'15px'}}>
        or
        </p>
        <p style={{marginBottom:'0em'}}>
          <span style={{fontWeight:'900', fontSize:'25px' ,border: "1px solid white", padding:'0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em'}}>
          FAMILY
          </span>
        </p>
      </div>
    </div>
    <div style={{fontSize:'21px', marginTop:'8em'}}>
      <p>
      You will be shown a series of pictures and words.
      </p>
      <p>
      Press «A» to associate the elements with the «FEMININE» and «CAREER» category.
      Press «L» to associate the elements with the «MASCULINE» and «FAMILY» category.
      </p>
      <p>
      If you make a pairing error, the system will notify you and provide the option to correct your answer.
      </p>
    </div>
    </Box>
    
    <div className="lykiocss-center" style={{margin:'0', fontWeight:'600', fontSize:'18px'}}>
      {t("Click on the space bar or on the left mouse button")}
    </div>
     
  </Row>
  </Container>
  </div>
</>;
}

function Sequence1(props) {
  const handleButtonClick = props.handleButtonClick;
  const [show, setShow] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const handleClose = () => {
      console.log("closing modal");
      setShow(false);
      setModalVisible(false);
  };

  const handleShow = () => {
      console.log("showing modal");
      setShow(true);
      setModalVisible(true);
  };

  const sendDataFromSequence = props.sendDataFromSequence;
  const sequenceIndex = props.sequenceIndex;
  const images = props.images;
  const leftAttribute1 = props.leftAttribute1;
  const leftAttribute2 = props.leftAttribute2;
  const rightAttribute1 = props.rightAttribute1;
  const rightAttribute2 = props.rightAttribute2;

  const [keyPressed, setKeyPressed] = useState(null);

  const [currentImage, setCurrentImage] = useState(0);

  const [correct, setCorrect] = useState(0);
  const [incorrect, setIncorrect] = useState(0);

  const [finished, setFinished] = useState(false);

  useEffect(() => {
      console.log('starting the timer...');
      setIsRunning(!isRunning);
  }, []);

  const animation = useSpring({
      from: { opacity: 0 },
      to: { opacity: 1 },
      config: { duration: "1500" }
  });

  useEffect(() => {
      console.log('modalVisible ', modalVisible);
      function handleKeyDown(event) {
          if (event.key === " " || event.key === "Spacebar") {
              handleClose();
          }
          if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
              setKeyPressed(event.key);
              console.log(event.key);
              console.log('currentImage ', currentImage);
              if(currentImage === 0){
                  console.log(`correct is ${correct}`);
                  handleClose();
                  setCorrect(correct + 1);
                  // console.log(`correct now is ${correct}`);
                  if (currentImage === images.length - 1) {
                      setIsRunning(!isRunning);
                      console.log('stopped the timer...');
                      sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                      handleButtonClick();
                  }
                  setCurrentImage(currentImage + 1);
              }else{
                  if (currentImage < images.length) {
                      if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
                          console.log(`correct is ${correct}`);
                          handleClose();
                          setCorrect(correct + 1);
                          // console.log(`correct now is ${correct}`);
                          if (currentImage === images.length - 1) {
                              setIsRunning(!isRunning);
                              console.log('stopped the timer...');
                              sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                              handleButtonClick();
                          }
                          setCurrentImage(currentImage + 1);
                      } else {
                          setIncorrect(incorrect + 1);
                          console.log(`wrong ${incorrect}`);
                          handleShow();
                          if (currentImage === images.length - 1) {
                              // setIsRunning(!isRunning);
                              // console.log('stopped the timer...');
                              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                              // handleButtonClick();
                          }
                      }
                  } else {
                      setIsRunning(!isRunning);
                      console.log('stopped the timer...');
                      sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                      handleButtonClick();
                  }
              }

          }
          if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
              setKeyPressed(event.key);
              console.log(event.key);
              console.log(currentImage);

              if (currentImage ===0) {
                  // console.log(`correct is ${correct}`);
                  handleClose();
                  setCorrect(correct + 1);
                  // console.log(`correct now is ${correct}`);
                  if (currentImage === images.length - 1) {
                      setIsRunning(!isRunning);
                      console.log('stopped the timer...');
                      sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                      handleButtonClick();
                  }
                  setCurrentImage(currentImage + 1);
              }else{
                  if (currentImage < images.length) {
                      if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
                          // console.log(`correct is ${correct}`);
                          handleClose();
                          setCorrect(correct + 1);
                          // console.log(`correct now is ${correct}`);
                          if (currentImage === images.length - 1) {
                              setIsRunning(!isRunning);
                              console.log('stopped the timer...');
                              sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                              handleButtonClick();
                          }
                          setCurrentImage(currentImage + 1);
                      } else {
                          setIncorrect(incorrect + 1);
                          console.log(`wrong ${incorrect}`);
                          handleShow();
                          if (currentImage === images.length - 1) {
                              // setIsRunning(!isRunning);
                              // console.log('stopped the timer...');
                              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                              // handleButtonClick();
                          }
                      }
                  } else {
                      setIsRunning(!isRunning);
                      console.log('stopped the timer...');
                      sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                      handleButtonClick();
                  }
              }

          }
      }

      // Add the event listener
      document.addEventListener('keydown', handleKeyDown);

      // Remove the event listener when the component unmounts
      return () => {
          document.removeEventListener('keydown', handleKeyDown);
      };
  }, [currentImage]);

  // Timer
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
      let interval = null;
      if (isRunning) {
          interval = setInterval(() => {
              setElapsedTime((elapsedTime) => elapsedTime + 1);
          }, 100);
      } else if (!isRunning && elapsedTime !== 0) {
          clearInterval(interval);
      }
      return () => clearInterval(interval);
  }, [isRunning, elapsedTime]);

  return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
      {images && images[currentImage] ?
          <Container>
              <Modal centered show={show} onHide={handleClose}>
                  <Modal.Body>
                      <div style={{ textAlign: "center", fontWeight: '500' }}>
                          <div style={{ display: "inline-block", color: 'red', fontWeight: '900', fontSize: '50px' }}>X</div>
                          <div style={{ textAlign: "center", fontSize: '18px' }}>{t("Attention!")}</div>
                          <div style={{ textAlign: "center", fontSize: '18px' }}>{t("This association is not correct!")}</div>
                          <div style={{ textAlign: "center", fontSize: '18px', marginTop: '10px' }}>{t("Press space to continue")}</div>
                      </div>
                  </Modal.Body>
              </Modal>
              <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                  <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em', textAlign: 'center' }} className="lykiocss-center">Use the buttons on the keyboard. Press A for masculine and L for feminine.</div>
              </Row>
              <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
                  <Col style={{flex:1}}>
                      <div className="fakeBtnMargin">
                          <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
                      </div>
                  </Col>
                  <Col style={{flex:1}}>
                      <div className="lykiocss-center">
                          <animated.div style={animation}>
                              {images[currentImage].url.startsWith('https') ?
                                  <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                                  :
                                  <div className="smaller-font" style={{
                                      background: "linear-gradient(to bottom, #960000, #f1414f)",
                                      color: 'white',
                                      padding: '0.6em',
                                      borderRadius: '0.2em',
                                      marginTop: '1em'
                                  }}>{images[currentImage].url}</div>
                              }

                          </animated.div>
                          {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
                      </div>
                  </Col>
                  <Col style={{flex:1}}>
                      <div className="fakeBtnMargin">
                          <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
                      </div>
                  </Col>
              </Row>
          </Container> :
          <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
              <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
          </Row>
      }
  </div>
  );
}

function Sequence2(props) {
  const handleButtonClick = props.handleButtonClick;
  const [show, setShow] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const handleClose = () => {
    console.log("closing modal");
    setShow(false);
    setModalVisible(false);
  };
  
  const handleShow = () => {
    console.log("showing modal");
    setShow(true);
    setModalVisible(true);
  };

  const sendDataFromSequence = props.sendDataFromSequence;
  const sequenceIndex = props.sequenceIndex;
  const images = props.images;
  const leftAttribute1 = props.leftAttribute1;
  const leftAttribute2 = props.leftAttribute2; 
  const rightAttribute1 = props.rightAttribute1;
  const rightAttribute2 = props.rightAttribute2;

  const [keyPressed, setKeyPressed] = useState(null);

  const [currentImage, setCurrentImage] = useState(0);

  const [correct, setCorrect] = useState(0);
  const [incorrect, setIncorrect] = useState(0);

  const [finished, setFinished] = useState(false);

  useEffect(() => {
    console.log('starting the timer...');
    setIsRunning(!isRunning);
  }, []);

  const animation = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: "1500" }
  });

  useEffect(() => {
    console.log('modalVisible ', modalVisible);
    function handleKeyDown(event) {
      if (event.key === " " || event.key === "Spacebar") {
        handleClose();
      }
      if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log('currentImage ',currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
            console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)),  percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
      if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log(currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
            // console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
    }

    // Add the event listener
    document.addEventListener('keydown', handleKeyDown);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentImage]);

  // Timer
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isRunning) {
      interval = setInterval(() => {
        setElapsedTime((elapsedTime) => elapsedTime + 1);
      }, 100);
    } else if (!isRunning && elapsedTime !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning, elapsedTime]);

  return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ? 
        <Container>
          <Modal centered show={show} onHide={handleClose}>
          <Modal.Body>
                <div style={{textAlign: "center", fontWeight:'500'}}>
                  <div style={{display: "inline-block", color:'red', fontWeight:'900', fontSize:'50px'}}>X</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("Attention!")}</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("This association is not correct!")}</div>
                  <div style={{textAlign: "center",fontSize:'18px', marginTop:'10px'}}>{t("Press space to continue")}</div>
                </div>
          </Modal.Body>
          </Modal>
          <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
            <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">Use the buttons on the keyboard. Press A for career and L for family.</div>
          </Row>
          <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="lykiocss-center">
                <animated.div style={animation}>
                  {images[currentImage].url.startsWith('https') ? 
                      <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                      :
                      <div className="smaller-font" style={{background: "linear-gradient(to bottom, #960000, #f1414f)",
                      color: 'white',
                      padding:'0.6em',
                      borderRadius:'0.2em',
                      marginTop: '1em'}}>{images[currentImage].url}</div>
                  }
                  
                </animated.div>
                {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
              </div>
            </Col>
          </Row>
        </Container> : 
                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
              </Row>
        }
      </div>
  );
}

function Sequence3(props) {
  const handleButtonClick = props.handleButtonClick;
  const [show, setShow] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const handleClose = () => {
    console.log("closing modal");
    setShow(false);
    setModalVisible(false);
  };
  
  const handleShow = () => {
    console.log("showing modal");
    setShow(true);
    setModalVisible(true);
  };

  const sendDataFromSequence = props.sendDataFromSequence;
  const sequenceIndex = props.sequenceIndex;
  const images = props.images;
  const leftAttribute1 = props.leftAttribute1;
  const leftAttribute2 = props.leftAttribute2; 
  const rightAttribute1 = props.rightAttribute1;
  const rightAttribute2 = props.rightAttribute2;

  const [keyPressed, setKeyPressed] = useState(null);

  const [currentImage, setCurrentImage] = useState(0);

  const [correct, setCorrect] = useState(0);
  const [incorrect, setIncorrect] = useState(0);

  const [finished, setFinished] = useState(false);

  useEffect(() => {
    console.log('starting the timer...');
    setIsRunning(!isRunning);
  }, []);

  const animation = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: "1500" }
  });

  useEffect(() => {
    console.log('modalVisible ', modalVisible);
    function handleKeyDown(event) {
      if (event.key === " " || event.key === "Spacebar") {
        handleClose();
      }
      if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log('currentImage ',currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
            console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)),  percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
      if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log(currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
            // console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
    }

    // Add the event listener
    document.addEventListener('keydown', handleKeyDown);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentImage]);

  // Timer
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isRunning) {
      interval = setInterval(() => {
        setElapsedTime((elapsedTime) => elapsedTime + 1);
      }, 100);
    } else if (!isRunning && elapsedTime !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning, elapsedTime]);

  return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ? 
        <Container>
          <Modal centered show={show} onHide={handleClose}>
          <Modal.Body>
                <div style={{textAlign: "center", fontWeight:'500'}}>
                  <div style={{display: "inline-block", color:'red', fontWeight:'900', fontSize:'50px'}}>X</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("Attention!")}</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("This association is not correct!")}</div>
                  <div style={{textAlign: "center",fontSize:'18px', marginTop:'10px'}}>{t("Press space to continue")}</div>
                </div>
          </Modal.Body>
          </Modal>
          <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
            <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">Use the buttons on the keyboard. Press A for masculine or career and L for feminine or family.</div>
          </Row>
          <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="lykiocss-center">
                <animated.div style={animation}>
                  {images[currentImage].url.startsWith('https') ? 
                      <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                      :
                      <div className="smaller-font"  style={{background: "linear-gradient(to bottom, #960000, #f1414f)",
                      color: 'white',
                      padding:'0.6em',
                      borderRadius:'0.2em',
                      marginTop: '1em'}}>{images[currentImage].url}</div>
                  }
                  
                </animated.div>
                {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
              </div>
            </Col>
          </Row>
        </Container> : 
                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
              </Row>
        }
      </div>
  );
}

function Sequence4(props) {
  const handleButtonClick = props.handleButtonClick;
  const [show, setShow] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const handleClose = () => {
    console.log("closing modal");
    setShow(false);
    setModalVisible(false);
  };
  
  const handleShow = () => {
    console.log("showing modal");
    setShow(true);
    setModalVisible(true);
  };

  const sendDataFromSequence = props.sendDataFromSequence;
  const sequenceIndex = props.sequenceIndex;
  const images = props.images;
  const leftAttribute1 = props.leftAttribute1;
  const leftAttribute2 = props.leftAttribute2; 
  const rightAttribute1 = props.rightAttribute1;
  const rightAttribute2 = props.rightAttribute2;

  const [keyPressed, setKeyPressed] = useState(null);

  const [currentImage, setCurrentImage] = useState(0);

  const [correct, setCorrect] = useState(0);
  const [incorrect, setIncorrect] = useState(0);

  const [finished, setFinished] = useState(false);

  useEffect(() => {
    console.log('starting the timer...');
    setIsRunning(!isRunning);
  }, []);

  const animation = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: "1500" }
  });

  useEffect(() => {
    console.log('modalVisible ', modalVisible);
    function handleKeyDown(event) {
      if (event.key === " " || event.key === "Spacebar") {
        handleClose();
      }
      if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log('currentImage ',currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
            console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)),  percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
      if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log(currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
            // console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
    }

    // Add the event listener
    document.addEventListener('keydown', handleKeyDown);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentImage]);

  // Timer
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isRunning) {
      interval = setInterval(() => {
        setElapsedTime((elapsedTime) => elapsedTime + 1);
      }, 100);
    } else if (!isRunning && elapsedTime !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning, elapsedTime]);

  return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ? 
        <Container>
          <Modal centered show={show} onHide={handleClose}>
          <Modal.Body>
                <div style={{textAlign: "center", fontWeight:'500'}}>
                  <div style={{display: "inline-block", color:'red', fontWeight:'900', fontSize:'50px'}}>X</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("Attention!")}</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("This association is not correct!")}</div>
                  <div style={{textAlign: "center",fontSize:'18px', marginTop:'10px'}}>{t("Press space to continue")}</div>
                </div>
          </Modal.Body>
          </Modal>
          <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
            <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">Use the buttons on the keyboard. Press A for masculine or career and L for feminine or family.</div>
          </Row>
          <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="lykiocss-center">
                <animated.div style={animation}>
                  {images[currentImage].url.startsWith('https') ? 
                      <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                      :
                      <div className="smaller-font" style={{background: "linear-gradient(to bottom, #960000, #f1414f)",
                      color: 'white',
                      padding:'0.6em',
                      borderRadius:'0.2em',
                      marginTop: '1em'}}>{images[currentImage].url}</div>
                  }
                  
                </animated.div>
                {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
              </div>
            </Col>
          </Row>
        </Container> : 
                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
              </Row>
        }
      </div>
  );
}

function Sequence5(props) {
  const handleButtonClick = props.handleButtonClick;
  const [show, setShow] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const handleClose = () => {
    console.log("closing modal");
    setShow(false);
    setModalVisible(false);
  };
  
  const handleShow = () => {
    console.log("showing modal");
    setShow(true);
    setModalVisible(true);
  };

  const sendDataFromSequence = props.sendDataFromSequence;
  const sequenceIndex = props.sequenceIndex;
  const images = props.images;
  const leftAttribute1 = props.leftAttribute1;
  const leftAttribute2 = props.leftAttribute2; 
  const rightAttribute1 = props.rightAttribute1;
  const rightAttribute2 = props.rightAttribute2;

  const [keyPressed, setKeyPressed] = useState(null);

  const [currentImage, setCurrentImage] = useState(0);

  const [correct, setCorrect] = useState(0);
  const [incorrect, setIncorrect] = useState(0);

  const [finished, setFinished] = useState(false);

  useEffect(() => {
    console.log('starting the timer...');
    setIsRunning(!isRunning);
  }, []);

  const animation = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: "1500" }
  });

  useEffect(() => {
    console.log('modalVisible ', modalVisible);
    function handleKeyDown(event) {
      if (event.key === " " || event.key === "Spacebar") {
        handleClose();
      }
      if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log('currentImage ',currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
            console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)),  percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
      if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log(currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
            // console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
    }

    // Add the event listener
    document.addEventListener('keydown', handleKeyDown);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentImage]);

  // Timer
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isRunning) {
      interval = setInterval(() => {
        setElapsedTime((elapsedTime) => elapsedTime + 1);
      }, 100);
    } else if (!isRunning && elapsedTime !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning, elapsedTime]);

  return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ? 
        <Container>
          <Modal centered show={show} onHide={handleClose}>
          <Modal.Body>
                <div style={{textAlign: "center", fontWeight:'500'}}>
                  <div style={{display: "inline-block", color:'red', fontWeight:'900', fontSize:'50px'}}>X</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("Attention!")}</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("This association is not correct!")}</div>
                  <div style={{textAlign: "center",fontSize:'18px', marginTop:'10px'}}>{t("Press space to continue")}</div>
                </div>
          </Modal.Body>
          </Modal>
          <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
            <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">Use the buttons on the keyboard. Press A for feminine and L for masculine.</div>
          </Row>
          <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="lykiocss-center">
                <animated.div style={animation}>
                  {images[currentImage].url.startsWith('https') ? 
                      <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                      :
                      <div className="smaller-font" style={{background: "linear-gradient(to bottom, #960000, #f1414f)",
                      color: 'white',
                      padding:'0.6em',
                      borderRadius:'0.2em',
                      marginTop: '1em'}}>{images[currentImage].url}</div>
                  }
                  
                </animated.div>
                {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
              </div>
            </Col>
          </Row>
        </Container> : 
                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
              </Row>
        }
      </div>
  );
}

function Sequence6(props) {
  const handleButtonClick = props.handleButtonClick;
  const [show, setShow] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const handleClose = () => {
    console.log("closing modal");
    setShow(false);
    setModalVisible(false);
  };
  
  const handleShow = () => {
    console.log("showing modal");
    setShow(true);
    setModalVisible(true);
  };

  const sendDataFromSequence = props.sendDataFromSequence;
  const sequenceIndex = props.sequenceIndex;
  const images = props.images;
  const leftAttribute1 = props.leftAttribute1;
  const leftAttribute2 = props.leftAttribute2; 
  const rightAttribute1 = props.rightAttribute1;
  const rightAttribute2 = props.rightAttribute2;

  const [keyPressed, setKeyPressed] = useState(null);

  const [currentImage, setCurrentImage] = useState(0);

  const [correct, setCorrect] = useState(0);
  const [incorrect, setIncorrect] = useState(0);

  const [finished, setFinished] = useState(false);

  useEffect(() => {
    console.log('starting the timer...');
    setIsRunning(!isRunning);
  }, []);

  const animation = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: "1500" }
  });

  useEffect(() => {
    console.log('modalVisible ', modalVisible);
    function handleKeyDown(event) {
      if (event.key === " " || event.key === "Spacebar") {
        handleClose();
      }
      if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log('currentImage ',currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
            console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)),  percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
      if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log(currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
            // console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
    }

    // Add the event listener
    document.addEventListener('keydown', handleKeyDown);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentImage]);

  // Timer
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isRunning) {
      interval = setInterval(() => {
        setElapsedTime((elapsedTime) => elapsedTime + 1);
      }, 100);
    } else if (!isRunning && elapsedTime !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning, elapsedTime]);

  return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ? 
        <Container>
          <Modal centered show={show} onHide={handleClose}>
          <Modal.Body>
                <div style={{textAlign: "center", fontWeight:'500'}}>
                  <div style={{display: "inline-block", color:'red', fontWeight:'900', fontSize:'50px'}}>X</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("Attention!")}</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("This association is not correct!")}</div>
                  <div style={{textAlign: "center",fontSize:'18px', marginTop:'10px'}}>{t("Press space to continue")}</div>
                </div>
          </Modal.Body>
          </Modal>
          <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
            <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">Use the buttons on the keyboard. Press A for feminine or career and L for masculine or family.</div>
          </Row>
          <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="lykiocss-center">
                <animated.div style={animation}>
                  {images[currentImage].url.startsWith('https') ? 
                      <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                      :
                      <div className="smaller-font" style={{background: "linear-gradient(to bottom, #960000, #f1414f)",
                      color: 'white',
                      padding:'0.6em',
                      borderRadius:'0.2em',
                      marginTop: '1em'}}>{images[currentImage].url}</div>
                  }
                  
                </animated.div>
                {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
              </div>
            </Col>
          </Row>
        </Container> : 
                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
              </Row>
        }
      </div>
  );
}

function Sequence7(props) {
  const handleButtonClick = props.handleButtonClick;
  const [show, setShow] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const handleClose = () => {
    console.log("closing modal");
    setShow(false);
    setModalVisible(false);
  };
  
  const handleShow = () => {
    console.log("showing modal");
    setShow(true);
    setModalVisible(true);
  };

  const sendDataFromSequence = props.sendDataFromSequence;
  const sequenceIndex = props.sequenceIndex;
  const images = props.images;
  const leftAttribute1 = props.leftAttribute1;
  const leftAttribute2 = props.leftAttribute2; 
  const rightAttribute1 = props.rightAttribute1;
  const rightAttribute2 = props.rightAttribute2;

  const [keyPressed, setKeyPressed] = useState(null);

  const [currentImage, setCurrentImage] = useState(0);

  const [correct, setCorrect] = useState(0);
  const [incorrect, setIncorrect] = useState(0);

  const [finished, setFinished] = useState(false);

  useEffect(() => {
    console.log('starting the timer...');
    setIsRunning(!isRunning);
  }, []);

  const animation = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: "1500" }
  });

  useEffect(() => {
    console.log('modalVisible ', modalVisible);
    function handleKeyDown(event) {
      if (event.key === " " || event.key === "Spacebar") {
        handleClose();
      }
      if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log('currentImage ',currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
            console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)),  percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
      if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
        setKeyPressed(event.key);
        console.log(event.key);
        console.log(currentImage);
        if (currentImage < images.length) {
          if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
            // console.log(`correct is ${correct}`);
            handleClose();
            setCorrect(correct + 1);
            // console.log(`correct now is ${correct}`);
            if(currentImage===images.length-1){
              setIsRunning(!isRunning);
              console.log('stopped the timer...');
              sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
              handleButtonClick();
            }
            setCurrentImage(currentImage + 1);
          } else {
            setIncorrect(incorrect + 1);
            console.log(`wrong ${incorrect}`);
            handleShow();
            if(currentImage===images.length-1){
              // setIsRunning(!isRunning);
              // console.log('stopped the timer...');
              // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
              // handleButtonClick();
            }
          }
        } else {
          setIsRunning(!isRunning);
          console.log('stopped the timer...');
          sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-incorrect,(images.length)),100)}, sequenceIndex);
          handleButtonClick();
        }
      }
    }

    // Add the event listener
    document.addEventListener('keydown', handleKeyDown);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentImage]);

  // Timer
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isRunning) {
      interval = setInterval(() => {
        setElapsedTime((elapsedTime) => elapsedTime + 1);
      }, 100);
    } else if (!isRunning && elapsedTime !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning, elapsedTime]);

  return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ? 
        <Container>
          <Modal centered show={show} onHide={handleClose}>
          <Modal.Body>
                <div style={{textAlign: "center", fontWeight:'500'}}>
                  <div style={{display: "inline-block", color:'red', fontWeight:'900', fontSize:'50px'}}>X</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("Attention!")}</div>
                  <div style={{textAlign: "center", fontSize:'18px'}}>{t("This association is not correct!")}</div>
                  <div style={{textAlign: "center",fontSize:'18px', marginTop:'10px'}}>{t("Press space to continue")}</div>
                </div>
          </Modal.Body>
          </Modal>
          <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
            <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">Use the buttons on the keyboard. Press A for feminine or career and L for masculine or family.</div>
          </Row>
          <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="lykiocss-center">
                <animated.div style={animation}>
                  {images[currentImage].url.startsWith('https') ? 
                      <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                      :
                      <div className="smaller-font" style={{background: "linear-gradient(to bottom, #960000, #f1414f)",
                      color: 'white',
                      padding:'0.6em',
                      borderRadius:'0.2em',
                      marginTop: '1em'}}>{images[currentImage].url}</div>
                  }
                  
                </animated.div>
                {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
              </div>
            </Col>
            <Col style={{flex:1}}>
              <div className="fakeBtnMargin">
                <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
              </div>
            </Col>
          </Row>
        </Container> : 
                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
              </Row>
        }
      </div>
  );
}

////////////////////

function FakeButton(props) {
  let word1 = props.text;
  let word2 = undefined;
  if(props.text.includes(" e ")){
    const words = props.text.split(' e ');
    word1 = words[0];
    word2 = words[1];
  }


  return (
    word2 ? <div>
      <div
      style={{
        background: "linear-gradient(to bottom, #960000, #f1414f)",
        color: 'white',
        padding: '10px 10px',
        textAlign: 'center',
        borderRadius: '0.5em',
        maxWidth: '15em',
        fontSize: '24px',
        fontWeight: '900',
        cursor: 'pointer',
      }}
    >
      <div>
      <p style={{margin:'1px', fontWeight:'900'}}>{t(word1)}</p>
      <p style={{margin:'1px', fontWeight:'900'}}>{t('or')}</p>
      <p style={{margin:'1px', fontWeight:'900'}}>{t(word2)}</p>
      </div>
    </div>
    </div> :
    <div
      style={{
        background: "linear-gradient(to bottom, #960000, #f1414f)",
        color: 'white',
        padding: '10px 10px',
        textAlign: 'center',
        borderRadius: '0.5em',
        maxWidth: '15em',
        fontSize: '24px',
        fontWeight: '900',
        cursor: 'pointer',
      }}
    >
      {t(word1)}
    </div>
  );
}